import { Component, Input, OnInit,EventEmitter, Output } from '@angular/core';
import _moment from "moment";
const moment = _moment;

@Component({
  selector: 'app-count-down-timer',
  templateUrl: './count-down-timer.component.html',
  styleUrls: ['./count-down-timer.component.scss']
})
export class CountDownTimerComponent implements OnInit {
  public minutes;
  public seconds;
  public estimatedTime;
  @Input() initialMinutes: number = 0;
  @Input() initialSeconds: number = 0;
  @Input() timerResolve: boolean = true;
  @Output() timeExceed = new EventEmitter();

  
  constructor() { }

  ngOnInit(): void {
    // this.minutes = this.initialMinutes;
    const time = moment(new Date()).toDate();
    // this.estimatedTime = moment(new Date()).add(30, 'm').toDate();
    this.estimatedTime = moment(new Date(this.initialMinutes)).toDate();
    this.minutes = Math.ceil((this.estimatedTime.getTime() - time.getTime())/(60*1000));

    if(this.minutes < 0){
           this.timeExceed.emit({minutes: this.minutes, timeExceed: true, index: this.initialSeconds});
      // this.minutes = -(this.minutes);
    }
    this.seconds = 0;
       // Implement countdown logic
    const countdownInterval = setInterval(() => {
               
        // if (this.seconds) {
        //   this.seconds--;
        //} else if (this.minutes) {
          this.minutes--;
          // this.seconds = 59;
        // }
        if(!this.timerResolve){
          
        clearInterval(countdownInterval);
      }
    }, 60000);
  }

}
